import React from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import { MenuBar } from './components/nav/NavBar';

interface IComponentProps { }

const App: React.FC<IComponentProps> = function ({ }) {
  return (
    <>
      <MenuBar />
      <Outlet />
    </>
  );
};

export default App;
